module.exports = __webpack_public_path__ + "img/icon-step-5.4b4a3c53.png";